// Navigation menu (new design)
// type: Stateful functional react component
// imported in : '../Routes/Dashboard.js'

// This is the navigation menu component. All required and used packages are imported at the top
// level. The menu is made using react-router <NavLink> component and routes are handled at a higher
// level than the navigation component. This component only changes the user's location based on
// the menu item selected.

// A little note about Navlink components:
// Example: <Navlink className="foo" activeClassName="bar" to="/buzz">
// Takes user to: connexing.io/buzz     default styles className = "foo"
// Styles className when the user is at connexing.io/buzz is "bar"
// exatc={true} is used when the route name is '/' to avoid it matching with all routes like '/buzz'
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "../../../../Assets/Styles/Navbar.scss";
import Logo from "../../../../Assets/Images/Logo-xsmall.svg";
import UserAvatar from "../../../../Assets/Images/sampleuser.png";
import Collapsible from "react-collapsible"; // nmp package used for handling the collapsing menu items
import { Bookmarks } from "./MenuItems"; // Static stored menu information (temporary)
import MenuItemIcon from "./Components/MenuItemIcon"; // the Plus icon with the animations displayed for menu items
import { Config } from "../../../../Config";
import axios from "axios";
import UnsavedChangesAlert from "../ShareElements/UnsavedChangesAlert/UnsavedChangesAlert";
import BookmarksBar from "./Components/Bookmarks";

const Navbar = (props) => {
  //component states
  const [LastMenuId, setLastMenuId] = useState(""); // The info of the last opened menu dropdown (parent)
  const [LastMenuIsOpen, setLastMenuIsOpen] = useState(false);
  const [MenuItems, setMenuItems] = useState([]); // imported from MenuItems.js file
  const [BookmarkList] = useState(Bookmarks); // imported from MenuItems.js file
  const [IsMobile, setIsMobile] = useState(false);
  const [UserInfo, setUserInfo] = useState();
  const [HasUnsaveChanges, setUnsavedChanges] = useState(false);
  const [PrevNavItem, setPrevNavItem] = useState("");

  useEffect(() => {
    window.localStorage.setItem("HasUnsaveChanges", 0); // 1 means true, 0 means false
    if (window.innerWidth < 450) {
      setIsMobile(true);
    }
    getUserMenuItems();
  }, []);

  const getUserInfo = () => {
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/profile",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        setUserInfo(Res.data);
        let RoleTypes = [];
        Res.data.roles.map((Role) => {
          RoleTypes.push(Role.roleType);
        });

        window.localStorage.setItem("UserUUID", Res.data.id);
        if (Res.data.superAdmin) {
          window.localStorage.setItem("IsSuperAdmin", 1); // 1: true, 0 :false
        } else {
          window.localStorage.setItem("IsSuperAdmin", 0); // 1: true, 0 :false
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  // this function calls an API and receives the user's navigation menu items based
  // on the permissions granted by the superadmin
  const getUserMenuItems = () => {
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/scope",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        createNavigationItems(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  // The main purpose of this function is to create a data with the same
  // structure we use in MenuItems.js file for navigation menu of the user.
  // The Data argument is passed down from getUserMenuItems() API response.
  const createNavigationItems = (Data) => {
    var Menu = []; // is going to be filled and set as state (MenuItems)

    // filtering items with null parentId (Parents)
    var Scopes = Data;
    var Filter = "parentId";
    var Keyword = null;
    var ParentScopes = Scopes.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    // using a for loop to iterate through the Parent scopes filtered above and get each
    // parent's childs
    for (let i = 0; i < ParentScopes.length; i++) {
      var ParentChilds = Data.filter((Child) => {
        return Child[Filter] === ParentScopes[i].id;
      });
      let Nodes = []; // submenus of each Parent
      ParentChilds.map((Child) => {
        Nodes.push({ Name: Child.name, Route: Child.route });
      });
      // this is the object pushed inside the Menu variable (array) to create nav menu items
      let ItemToPush = {
        Name: ParentScopes[i].name,
        Route: ParentScopes[i].route,
        Index: ParentScopes[i].index,
        ClassName: "nav-parent",
        MobileIcon: "DashboardMobile",
        Nodes: Nodes, // the Nodes Array created above for each parent
      };

      if (ParentScopes[i].name === "Dashboard") {
        ItemToPush.IsExact = true; // for React-router to match the exact url (route) for activeClassName
      } else {
        ItemToPush.IsExact = false;
      }

      if (ParentScopes[i].index === 13 || ParentScopes[i].index === 18) {
        ItemToPush.IsLastItem = true;
      } else {
        ItemToPush.IsLastItem = false;
      }

      Menu.push(ItemToPush);
    }

    let FirstGroup = [{}, {}, {}, {}, {}, {}];
    let SecondGroup = [{}, {}];
    let LastGroup = [{}, {}, {}];
    Menu.map((Item) => {
      if (Item.Index === 0) {
        FirstGroup[0] = Item;
      }
      if (Item.Index === 1) {
        FirstGroup[1] = Item;
      }
      if (Item.Index === 4) {
        FirstGroup[2] = Item;
      }
      if (Item.Index === 7) {
        FirstGroup[3] = Item;
      }
      if (Item.Index === 10) {
        FirstGroup[4] = Item;
      }
      if (Item.Index === 13) {
        FirstGroup[5] = Item;
      }

      if (Item.Index === 16) {
        SecondGroup[0] = Item;
      }
      if (Item.Index === 18) {
        SecondGroup[1] = Item;
      }
      if (Item.Index === 20) {
        LastGroup[0] = Item;
      }
      if (Item.Index === 24) {
        LastGroup[1] = Item;
      }
      if (Item.Index === 28) {
        LastGroup[2] = Item;
      }
    });
    let MenuArray = FirstGroup.concat(SecondGroup); // contains empty objects
    if (window.innerWidth > 1024) {
      // only show LastGroup when view bigger than TabletSmall size
      MenuArray = MenuArray.concat(LastGroup);
    }

    let MenuItems = []; // only storing items (objects) that contain data
    MenuArray.map((Item, i) => {
      if (Item.Name !== undefined) {
        MenuItems.push(Item);
      }
    });

    setMenuItems(MenuItems);
    getUserInfo(MenuItems);
  };

  // These function handle opening the clicked menu dropdown,
  // its icon rotation and closes the last open
  // menu in case there is one(not the first time).
  const openMenuDropDown = (MenuName) => {
    document.getElementById(MenuName + "-hr").classList.add("hr-rotated");
    document.getElementById(MenuName + "-vr").classList.add("vr-rotated");
    //because it is initially and empty string, this is to avoid error on first menu open
    if (LastMenuId.length !== 0 && LastMenuIsOpen && MenuName !== LastMenuId) {
      closeMenu(LastMenuId);
    }
    setLastMenuId(MenuName);
    if (LastMenuIsOpen && LastMenuId === MenuName) {
      setLastMenuIsOpen(false);
      restartLastItem();
    } else {
      setLastMenuIsOpen(true);
    }
  };

  const closeMenu = (MenuName) => {
    setLastMenuId(MenuName);
    setLastMenuIsOpen(false);
    document.getElementById(LastMenuId).click();
  };

  const restartLastItem = () => {
    setLastMenuIsOpen(false);
  };

  const restartArrow = (MenuName) => {
    document.getElementById(MenuName + "-hr").classList.remove("hr-rotated");
    document.getElementById(MenuName + "-vr").classList.remove("vr-rotated");
  };

  const validateNavigation = (e, Id) => {
    setPrevNavItem(Id);
    let UnsavedChangesStatus = parseInt(
      window.localStorage.getItem("HasUnsaveChanges")
    ); //true: 1, false: 0
    if (UnsavedChangesStatus === 0) {
      document.getElementById(Id).click();
    } else if (UnsavedChangesStatus === 1) {
      e.preventDefault();
      setUnsavedChanges(true);
    }
  };
  const discard = () => {
    window.localStorage.setItem("HasUnsaveChanges", 0);
    document.getElementById(PrevNavItem).click();
    setUnsavedChanges(false);
  };
  const saveAndLeave = () => {
    document.getElementById("save-btn").click();
    setTimeout(() => {
      let UnsavedChangesStatus = parseInt(
        window.localStorage.getItem("HasUnsaveChanges")
      ); //true: 1, false: 0
      if (UnsavedChangesStatus === 1) {
        setUnsavedChanges(false);
        return null;
      } else {
        document.getElementById(PrevNavItem).click();
        setUnsavedChanges(false);
      }
    }, 1500);
  };

  const nameToLabelId = (MenuName) => {
    switch (MenuName) {
      case "Positions":
        return translateText("positions");
      case "Skills":
        return translateText("skills");
      case "Trainings":
        return translateText("trainings");
      case "Data Import":
        return translateText("data_import");
      case "Security Settings":
        return translateText("security_settings");
      case "System Settings":
        return translateText("system_settings");
      case "Dashboard":
        return translateText("dashboard");
      case "Jobs":
        return translateText("jobs");
      case "Activities":
        return translateText("activities");
      case "Projects":
        return translateText("projects");
      case "Employees":
        return translateText("employees");
    }
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0]?.label_value;
  };

  //TODO: update service monitoring localization

  const nodeToLabelId = (NodeName) => {
    switch (NodeName) {
      case "Projects":
        return translateText("projects");
      case "Candidates Search":
        return translateText("candidates_search");
      case "Activities":
        return translateText("activities");
      case "Employee List":
        return translateText("employee_list");
      case "Employee Profile":
        return translateText("employee_profile");
      case "Positions List":
        return translateText("position_list");
      case "Positions Details":
        return translateText("position_details");
      case "Skills & Competencies":
        return translateText("skills_and_competencies");
      case "Training List":
        return translateText("training_list");
      case "Data Import":
        return translateText("data_import");
      case "Data Import History":
        return translateText("data_import_history");
      case "Feature List":
        return translateText("feature_list");
      case "User Management":
        return translateText("user_management");
      case "Security Profiles":
        return translateText("security_profiles");
      case "ACLs":
        return translateText("acl");
      case "Vacancies":
        return translateText("vacancies");
      case "Application Settings":
        return translateText("application_settings");
      case "Localization":
        return translateText("localization");
      case "Create Vacancies":
        return translateText("create-vacancies");
      case "Create Projects":
        return translateText("create_projects");
      case "Create Activities":
        return translateText("create_activities");
      case "System metrics":
        return translateText("system_metrics");
      case "Photo uploader":
        return translateText("photo_uploader");
      case "Service Monitoring":
        return translateText("services_monitoring");
      case "System Metrics":
        return translateText("system_metrics");
      default:
        return NodeName;
    }
  };
  const hideNavMenu = () => {
    document.getElementById("navigation-menu").classList.remove("is-open");
    document.getElementById("menu-burger").checked = false;
  };

  const handleNavClassName = () => {
    if (window.innerWidth <= 450) {
      return "main-nav";
    } else {
      return MenuItems.length === 0 ? "hidden" : "main-nav";
    }
  };

  // Component view:
  return (
    <React.Fragment>
      {HasUnsaveChanges ? (
        <UnsavedChangesAlert
          close={() => setUnsavedChanges(false)}
          saveAndLeave={() => saveAndLeave()}
          discardAndLeave={() => discard()}
          LangData={props.LangData}
        />
      ) : null}
      <div className="navigation">
        {UserInfo === undefined ? null : (
          <BookmarksBar
            IsMobile={IsMobile}
            BookmarkList={BookmarkList}
            Logo={Logo}
            hideNavMenu={() => hideNavMenu()}
            UserInfo={UserInfo}
            UserAvatar={UserAvatar}
            LangData={props.LangData}
            setConfirmLogoutIsOpen={(Bool) =>
              props.setConfirmLogoutIsOpen(Bool)
            }
            NavBookmarksGuideIsOpen={props.NavBookmarksGuideIsOpen}
            SetNavBookmarksGuideIsOpen={(Bool) =>
              props.SetNavBookmarksGuideIsOpen(Bool)
            }
            ToggleNextDialog={() => props.ToggleSixthGuide()}
            TogglePreviousDialog={() => props.ToggleFourthGuide()}
            JumpToStep={(Step) => props.JumpToStep(Step)}
            CloseGuide={() => props.CloseGuide()}
            HasAdditionalStep={props.HasAdditionalStep}
          />
        )}
        <nav className={handleNavClassName()} id="main-nav">
          {MenuItems.length > 0 ? (
            <React.Fragment>
              {MenuItems.length === 0 || props.LangData === undefined ? null : (
                <React.Fragment>
                  {MenuItems.map((MenuItem) => (
                    <React.Fragment>
                      {IsMobile ? (
                        <React.Fragment>
                          {MenuItem.Route === "/securitySettings" ||
                          MenuItem.Route === "/ai" ? null : (
                            <Collapsible
                              onClosing={() => restartArrow(MenuItem.Route)}
                              multiple={true}
                              transitionTime={200}
                              trigger={
                                <div
                                  onClick={() =>
                                    openMenuDropDown(MenuItem.Route)
                                  }
                                  id={MenuItem.Route}
                                  to={MenuItem.Route}
                                  className={MenuItem.ClassName}
                                >
                                  <MenuItemIcon
                                    IsMobile={IsMobile}
                                    Id={MenuItem.Route}
                                  />
                                  {nameToLabelId(MenuItem.Name)}
                                </div>
                              }
                            >
                              {IsMobile ? (
                                <section className="nav-nodes-list">
                                  {MenuItem.Nodes.map((ItemNode) => (
                                    <NavLink
                                      className="nav-node"
                                      activeClassName="active-node"
                                      to={ItemNode.Route}
                                      onClick={() => hideNavMenu()}
                                    >
                                      {nodeToLabelId(ItemNode.Name)}
                                    </NavLink>
                                  ))}
                                </section>
                              ) : (
                                <section className="nav-nodes-list">
                                  {MenuItem.Nodes.map((ItemNode) => (
                                    <NavLink
                                      className="nav-node"
                                      activeClassName="active-node"
                                      to={ItemNode.Route}
                                      onClick={(e) =>
                                        validateNavigation(
                                          e,
                                          "nav-" + ItemNode.Route
                                        )
                                      }
                                      id={"nav-" + ItemNode.Route}
                                    >
                                      <i className="feather-circle"></i>
                                      {nodeToLabelId(ItemNode.Name)}
                                    </NavLink>
                                  ))}
                                </section>
                              )}
                            </Collapsible>
                          )}
                        </React.Fragment>
                      ) : (
                        <Collapsible
                          onClosing={() => restartArrow(MenuItem.Route)}
                          multiple={true}
                          transitionTime={200}
                          trigger={
                            <div
                              onClick={() => openMenuDropDown(MenuItem.Route)}
                              id={MenuItem.Route}
                              to={MenuItem.Route}
                              className={MenuItem.ClassName}
                            >
                              <MenuItemIcon
                                IsMobile={IsMobile}
                                Id={MenuItem.Route}
                              />
                              {nameToLabelId(MenuItem.Name)}
                            </div>
                          }
                        >
                          {IsMobile ? (
                            <section className="nav-nodes-list">
                              {MenuItem.Nodes.map((ItemNode) => (
                                <NavLink
                                  className="nav-node"
                                  activeClassName="active-node"
                                  to={ItemNode.Route}
                                  onClick={() => hideNavMenu()}
                                >
                                  {nodeToLabelId(ItemNode.Name)}
                                </NavLink>
                              ))}
                            </section>
                          ) : (
                            <section className="nav-nodes-list">
                              {MenuItem.Nodes.map((ItemNode) => (
                                <NavLink
                                  className="nav-node"
                                  activeClassName="active-node"
                                  to={ItemNode.Route}
                                  onClick={(e) =>
                                    validateNavigation(
                                      e,
                                      "nav-" + ItemNode.Route
                                    )
                                  }
                                  id={"nav-" + ItemNode.Route}
                                >
                                  <i className="feather-circle"></i>
                                  {nodeToLabelId(ItemNode.Name)}
                                </NavLink>
                              ))}
                            </section>
                          )}
                        </Collapsible>
                      )}
                      {MenuItem.IsLastItem ? (
                        <div className="hr-line-silver"></div>
                      ) : null}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              )}
            </React.Fragment>
          ) : null}
        </nav>
      </div>
    </React.Fragment>
  );
};
export default Navbar;
